import { atom } from "nanostores";
import { useStore } from "@nanostores/react";

const $currentProjectId = atom<string | null>(null);

export const useCurrentProjectId = () => useStore($currentProjectId);

export const setCurrentProjectId = (projectId: string | null) => {
  $currentProjectId.set(projectId);
};
